import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Reports = () => {
  return (
    <Container>

      <Cards>

        <Card target='blank' href="./pdf/cross global annual report 2024.pdf" >

          <div className='imgContainer' >
            <img className='image' src="./images/reports/7.jpg" alt="" />
          </div>

          <h3>Annual Report 2024</h3>

          <div to='' className='link'>
            <a target='blank' href="./pdf/cross global annual report 2024.pdf">READ THE FULL REPORT</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>
          
        </Card>

        <Card target='blank' href="./pdf/Annual Report - 2023.pdf" >

          <div className='imgContainer' >
            <img className='image' src="./images/reports/6.jpg" alt="" />
          </div>

          <h3>Annual Report 2023</h3>

          <div to='' className='link'>
            <a target='blank' href="./pdf/Annual Report - 2023.pdf">READ THE FULL REPORT</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>
          
        </Card>

          <Card target='blank' href="./pdf/CG Annual report _ 2022.pdf" >

                <div className='imgContainer' >
                  <img className='image' src="./images/reports/5.jpg" alt="" />
                </div>

                <h3>Annual Report 2022</h3>

                <div to='' className='link'>
                  <a target='blank' href="./pdf/CG Annual report _ 2022.pdf">READ THE FULL REPORT</a>
                  <div>
                    <img className='arrow' src="./icons/arrow.png" alt="" />
                  </div>
                </div>
          
        </Card>

        <Card target='blank' href="./pdf/Cross Global Annual Report - 2021.pdf" >

          <div className='imgContainer' >
            <img className='image' src="./images/reports/1.jpg" alt="" />
          </div>

          <h3>Annual Report 2021</h3>

          <div to='' className='link'>
            <a target='blank' href="./pdf/Cross Global Annual Report - 2021.pdf">READ THE FULL REPORT</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>
          
        </Card>

        <Card target='blank' href='./pdf/CROSS GLOBAL ASIA FOUNDATION - Financial Report FY23.pdf'>

        
          <div className='imgContainer'>
            <img className='image' src="./images/reports/4.jpg" alt="" />
          </div>

          <h3>CGAF - Audit FY - 2022</h3>

          <div className='link'>
            <a target='blank' href='./pdf/CROSS GLOBAL ASIA FOUNDATION - Financial Report FY23.pdf'>AUDIT FY - 2021</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>

        </Card>

      </Cards>

      <Anti>
            <h2>
                <img className='sdg' src="./images/main/12.jpg" alt="" /> on Anti-Human Trafficking
            </h2>

            <section>
                <div>
                    <img src="./images/final-icon/post 1.png" alt="" />
                    <p>5.2: Eliminate all forms of violence against all women and girls in public and private spheres, including trafficking and sexual, and other types of exploitation.</p>
                </div>

                <div>
                    <img src="./images/final-icon/post 2.png" alt="" />
                    <p>8.7: Take immediate and effective measures to eradicate forced labour, end modern slavery and human trafficking and secure the prohibition and elimination of the worst forms of child labour, including recruitment and use of child soldiers. including recruitment and use of child soldiers, and by 2025 end child labour in all its forms.”</p>
                </div>

                <div>
                    <img src="./images/final-icon/post 3.png" alt="" />
                    <p>10.7: Facilitate orderly, safe, and responsible migration and mobility of people, including through the implementation of planned and well-managed migration policies.</p>
                </div>

                <div>
                    <img src="./images/final-icon/post 4.png" alt="" />
                    <p>16.2: End abuse, exploitation, trafficking and all forms of violence and torture against children.</p>
                    
                </div>
                {/* <div>
                    <div></div>
                    <p>
                        <h3>Donate us to fight against human trafficking</h3>
                        <button><Link to='/donate'>DONATE</Link></button>
                    </p>
                    
                </div> */}
            </section>

        </Anti>

    </Container>
  )
}

export default Reports

const Anti = styled.div`


    padding-top: 8rem;

    .sdg{
        width: 300px;

        
    @media (max-width:500px) {
        width: 200px;
    }
    }

    @media (max-width:500px) {
        padding-top: 4rem;
    }

    h2{
        font-size: clamp(2rem, 3vw, 3rem);
       padding-bottom: 3rem;
    }

    section{


        div{
            
            display:flex;
            padding: 2rem 0;
            justify-content: space-between;
            align-items: center;

            button{
                border: none;
                font-size: clamp(1rem, 2.4vw, 1.3rem);
                padding: 1rem 2rem;
                border-radius: 30px;
                margin-top: 1.4rem;
                background-color: #fdcb4a;
                
                a{
                    color: black;
                }

                &:hover{
                    background-color: black;
                }
                &:hover a{
                    color: white;
                }
                
            }

            @media (max-width:500px) {
                flex-direction: column;
            }

            img{
                width: 200px;
                height: 200px;
                object-fit: cover;
            }
            p{
                width:70%;
                font-size: clamp(1rem, 5vw, 1.5rem);

                @media (max-width:500px) {
                    width: 100%;
                    padding-top: 2rem;
                }

            }
        }
    }

      @media (max-width:500px) {
      padding: 1rem 2rem;
    }
`

const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 2rem 0rem;
  /* margin-top: 3rem; */
  margin-bottom: 8rem;
  
`

const Cards = styled.div`
  display: flex;
  gap: 60px;
  justify-content: center;
  /* height: 70vh; */
  align-items: center;
  flex-wrap: wrap;
  
  

  @media (max-width:600px) {
    flex-direction: column;
    gap: 40px;
    padding: 2rem 2rem;
  }
  
`

const Card = styled.a`

  /* width: 50%; */
  /* overflow: hidden; */

  @media (max-width:650px) {
    border-bottom: 1px #00000053 solid;
    padding-bottom: 2rem;
  }

 
  
   

  &:hover .image{
    transform: scale(1.05);
  }

  &:hover .arrow{
    transform: translateX(10px);
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
  }


  .link{
    display: flex;
    gap: 15px;
    align-items: center;
    color: black;

    a{
      color: black;
    }

    div{
      img{
        width: 20px;
        transition: 0.3s all ease-in-out;
      }
    }
  }

  h3{
    font-size: clamp(1.5rem, 2.5vw, 4rem);
    padding: 1rem 0;
  }
  
  p{
    font-size: clamp(1rem, 1vw, 1.5rem);
  }

  .imgContainer{
    width: 100%;
    border-radius: 9px;
    overflow: hidden;
    img{
      width: 100%;
      object-fit: cover;
      transition: 0.3s all ease-in-out;
      border-radius: 9px;
    }
  }
`